// extracted by mini-css-extract-plugin
export default {"parameter":"Y3NHR","parameter--wide":"ZxPWj","parameter__strong":"sRYC8"};